.status {
  display: inline-block;
  margin-right: 0.2rem;
  margin-bottom: 0.4rem;
  vertical-align: middle;
}

.button {
  display: block;
}
